// _basic/demo-detail
import React, { useCallback, useState } from 'react';
import View from 'src/pages/_basic/detail';
import AppRender from 'src/routes/app-render';
import { useForm } from 'src/hooks/use-form';
import { myApi } from 'src/api/_basic/vm-view';
import useToast from 'src/utils/toast-utils';

const Page = () => {
  const { handleNavigate, itemNavigate } = useForm();
  const { toastError } = useToast();
  /**
   * Option A: useState({}); //empty 
   * UX: Faster initial render, may flicker
   * Performance: No delay
   * Use when: Data loads quickly and you're OK rendering placeholders
   */
  // const [data, setData] = useState({});

  /**
   * Option B: useState(); //undefined
   * UX: Waits to render until data ready
   * Performance: Slight delay
   * Use when: Data is slow or important to show correctly the first time
   */
  const [data, setData] = useState();

  // Memoize the API call function to avoid infinite loop
  const fetchData = useCallback(async () => {
    if(itemNavigate){
      const {result, error} = await myApi.getDetail(itemNavigate);
      if(result){
        setData(result);
      }else if(error){
        toastError(error);
      }
    }
  }, []); // No dependencies, so this function will only be created once

  return (
    <AppRender apiCall={fetchData}>
      {data && <View onNavigate={handleNavigate} item={data} />}
    </AppRender>
  );
};

export default Page;
